import { useMutation } from '@tanstack/react-query';
import { ApiError } from 'src/error/ApiError';
import { api } from 'src/common/utils/api';

type InviteResend = {
  masked_email: string;
};

type ResendVariables = {
  tenantId: string;
  token: string;
};

export const useResendExpiredInvite = () => {
  const { mutateAsync, data, error, isPending, isError, reset } = useMutation<
    { data: InviteResend },
    Error,
    ResendVariables
  >({
    // A dead or already-accepted invite, or one that has used up its resends, is an ordinary
    // outcome of clicking an old link rather than an incident, so those statuses are handled
    // here instead of being reported.
    mutationFn: ({ tenantId, token }) =>
      api.post<InviteResend>(
        `public/invite-resend/${encodeURIComponent(tenantId)}/${encodeURIComponent(token)}`,
        undefined,
        { expectedStatuses: [404, 409, 429] },
      ),
  });

  return {
    resendInvite: mutateAsync,
    maskedEmail: data?.data.masked_email,
    isSending: isPending,
    isError,
    errorStatus: error instanceof ApiError ? error.status : undefined,
    reset,
  };
};
